module.exports = __webpack_public_path__ + "static/media/guestsSelected.c5c4b5e5.svg";